import React, { useState, useRef } from "react";
import Widget from "../../widget/Widget";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import AutoSizer from "react-virtualized/dist/commonjs/AutoSizer";
import Table from "react-virtualized/dist/commonjs/Table";
import Column from "react-virtualized/dist/commonjs/Table/Column";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton"
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ActionIcon from "@mui/icons-material/MoreHoriz";
import SetupReportDialog from "./SetupReportDialog";
import Replay from "@mui/icons-material/Replay";
import Edit from "@mui/icons-material/Edit";
import Delete from "@mui/icons-material/Delete";
import GetAppIcon from "@mui/icons-material/GetApp";
import FileCopyIcon from '@mui/icons-material/FileCopy';
const uuidv4 = require("uuid/v4");
//unused: const timelengthmap = { "day": 1, "week": 7, "month": 30 }
function timeLabel(ts) {
  //stamp to label
  try {
    const date = new Date(ts)
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
      //hour: date.getHours() !== 0 || date.getMinutes() !== 0 ? 'numeric' : undefined,
      //minute: date.getMinutes() !== 0 ? '2-digit' : undefined
    });
    //toISOString();
  } catch {
    return "";
  }
}

const recurLableMap = { "1": "Daily", "7": "Weekly", "0": "Other" };
//unused:
// const ExportLink = ({ props }) => {
//   const expire =
//     parseFloat(props.expire) ||
//     parseFloat(props.end_time) + 7 * 24 * 3600 * 1000;
//   if (props.url)
//     return Date.now() > expire ? (
//       <div>Expired</div>
//     ) : (
//       <a target="_blank" rel="noopener noreferrer" href={props.url}>
//         Click
//       </a>
//     );
//   return <div></div>;
// };

const handleDownload = (url) => {
  const link = document.createElement("a");
  link.href = url; // replace with your file path or URL
  link.download = "Export.zip";    // suggested filename 
  link.click();
};

const _rowStyle = ({ index }) => {
  let style = { borderBottom: "1px solid #e0e0e0" };
  if (index < 0) {
    style.textTransform = "none";
  } else if (index % 2 === 0) {
    // won't see border without this
    style.zIndex = 1;
  } else {
    style.backgroundColor = "#fafafa";
  }
  return style;
};


export const ACTION_NONE = -1;
export const ACTION_EDIT = 1;
export const ACTION_DUPLICATE = 2;
export const ACTION_DOWNLOAD = 3;
export const ACTION_DELETE = 4;
export const ACTION_REMOVE = 5;
const EXPORT_RECUR_ACTIONS = () => [
  {
    id: 1,
    label: "Edit",
    icon: Edit,
  },
  {
    id: 2,
    label: "Duplicate",
    icon: FileCopyIcon,
  },
  {
    id: 4,
    label: "Delete",
    icon: Delete,
  },
];

const EXPORT_ACTIONS = () => [
  {
    id: 3,
    label: "Download",
    icon: GetAppIcon,
  },
  {
    id: 2,
    label: "Resubmit",
    icon: Replay,
  },
  {
    id: 5,
    label: "Delete",
    icon: Delete,
  },
];

const ExportWidget = (props) => {
  const [exportDialogOpen, setExportDialogOpen] = useState(false);
  const [exportDialogTitle, setExportDialogTitle] = useState("");
  const [exportMenuAnchor, setExportMenuAnchor] = useState(false);
  const [exportCat, setExportCat] = useState(2);
  const [action, setAction] = useState(0);
  const selectedExport = useRef(null);
  //completed:
  // sort by 'request_time'
  // start_time, end_time
  // status
  // tags[]
  // url
  const recurringData = props.data && props.data.filter((s) => (s.status === "recurring" || (s.status === "requested" && s?.options?.recur === "1"))).sort((b, a) => a.request_time - b.request_time);
  const sortedData =
    props.data && props.data.filter((s) => s.status !== "recurring").sort((b, a) => a.request_time - b.request_time);
  //console.log("recurring and sorted",recurringData,sortedData);

  function setExportOptions(changes) {
    if (action === ACTION_EDIT && selectedExport.current?.request_time) {
      //console.log("delete old recurrence",selectedExport.current?.request_time);
      removeExportRequests(selectedExport.current?.request_time, selectedExport.current?.guuid);
      selectedExport.current = null;
    }
    props.newRequest(changes);
  }
  function exportOptions() {
    return {
      tags: selectedExport?.current?.tags.map((t) => {
        const sepidx = t.indexOf('_')
        return { 'stack': t.slice(0, sepidx), 'attribute': t.slice(sepidx + 1), 'guuid': uuidv4() }
      }) || [],
      options: selectedExport?.current?.options || {}
    };
  }
  const getName = (op) => {
    const nm = op?.fname ?? ""
    const note = op?.note ?? ""
    if (nm && note) {
      return nm + " | " + note
    }
    if (nm) {
      return nm
    }
    if (note) {
      return note
    }
    return "Unnamed"
  }

  function removeExportRequests(request_time, guuid) {
    props.removeExport(request_time, guuid);
  }

  function removeExportCompleted(request_time, guuid) {
    props.removeExport(request_time, guuid, true);
  }

  const handleAction = (action) => {
    console.log("action is", action, exportCat, selectedExport);
    if (action?.id && selectedExport.current) {
      setAction(action.id);
      switch (action.id) {
        case ACTION_EDIT:
          setExportDialogOpen(true);
          break;
        case ACTION_DUPLICATE:
          setExportDialogOpen(true);
          break;
        case ACTION_DOWNLOAD:
          handleDownload(selectedExport.current?.url)
          break;
        case ACTION_DELETE:
          removeExportRequests(selectedExport.current?.request_time, selectedExport.current?.guuid);
          break;
        case ACTION_REMOVE:
          removeExportCompleted(selectedExport.current?.request_time, selectedExport.current?.guuid);
          break;
        default:
          throw Error("unknown action", action.id);
      }
    }
  }

  //Need some sort of flex container here so table stays in widget

  return (
    <>
      <Widget {...props} configurable={false}>
        <div
          style={{ width: "100%", height: "100%" }}
          onClick={(ev) => {
            // stop propagation so this stack remains selected
            ev.stopPropagation();
          }}
        >
          <Card style={{ height: "100%" }}>
            { !props.readOnly &&
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginLeft: "1rem",
                marginRight: "1rem",
                marginTop: "1rem",
              }}
            >
              <Button
                variant="contained"
                size="small"
                color="primary"
                onClick={() => {
                  selectedExport.current = null;
                  setAction(0);
                  setExportDialogTitle("New Export Request");
                  setExportDialogOpen(true);
                }}
                style={{
                  fontSize: "0.825rem",
                  textTransform: "none",
                }}
              >
                New Export Request
              </Button>
            </div> }
            <CardContent style={{ height: "calc(100% - 31px)" }}>
              <div style={{ fontWeight: "bold", marginTop: 20, marginBottom: 10 }}>Scheduled Exports</div>
              <div style={{ marginTop: 0, height: "30%" }}>
                {recurringData && (
                  <AutoSizer>
                    {({ width, height }) => (
                      <Table
                        width={width}
                        height={height}
                        headerHeight={30}
                        rowHeight={30}
                        rowCount={recurringData.length}
                        rowGetter={({ index }) => recurringData[index] || []}
                        rowStyle={_rowStyle}
                      >
                        <Column
                          dataKey=""
                          label="Recurrence"
                          cellRenderer={({ rowData }) => (
                            <div title={rowData.tags}>
                              {recurLableMap[rowData.options?.["recur-days"] ?? "0"]}
                            </div>
                          )}
                          width={110}
                          flexGrow={0}
                        />
                        <Column
                          dataKey=""
                          label="Details"
                          cellRenderer={({ rowData }) => getName(rowData.options)}
                          //cellRenderer={({ rowData }) => ((rowData.options?.name ?? "") + ((rowData.options?.name && rowData.options?.note) ? " | " : "") + (rowData.options?.note ?? "")) }
                          width={610}
                          flexGrow={0}
                        />
                        <Column
                          dataKey=""
                          label="Next Export At"
                          cellRenderer={({ rowData }) => (
                            <div title={rowData.tags}>
                              {" "}
                              {timeLabel(
                                rowData.options?.["execute-after"]
                                || rowData.options?.end
                                || rowData.request_time
                              )}
                            </div>
                          )}
                          width={200}
                          flexGrow={0}
                        />
                        <Column
                          dataKey=""
                          label="Actions"
                          cellRenderer={({ rowData }) => (
                            <IconButton
                              title="Click for menu of actions"
                              onClick={(e) => {
                                selectedExport.current = rowData;
                                setExportCat(1)
                                setExportMenuAnchor(e.currentTarget);
                              }}
                              style={{ padding: 6 }}
                            >
                              <ActionIcon />
                            </IconButton>
                          )}
                          width={90}
                          flexGrow={0}
                        />
                      </Table>
                    )}
                  </AutoSizer>
                )}
                {!props.data && (
                  <div>No export jobs. Use settings to create.</div>
                )}
              </div>
              <div style={{ fontWeight: "bold", marginTop: 20, marginBottom: 10 }}>Export Queue</div>
              <div style={{ marginTop: 0, height: "100%" }}>
                {sortedData && (
                  <AutoSizer>
                    {({ width, height }) => (
                      <Table
                        width={width}
                        height={height}
                        headerHeight={30}
                        rowHeight={30}
                        rowCount={sortedData.length}
                        rowGetter={({ index }) => sortedData[index] || []}
                        rowStyle={_rowStyle}
                      >
                        <Column
                          dataKey=""
                          label="Status"
                          cellRenderer={({ rowData }) =>

                            (rowData.expire && Date.now() > rowData.expire) ? "Expired" : (rowData.status === "finished" ? "Complete" : rowData.status.charAt(0).toUpperCase() + rowData.status.slice(1))

                          }
                          width={110}
                          flexGrow={0}
                        />
                        <Column
                          dataKey=""
                          label="Details"
                          cellRenderer={({ rowData }) => getName(rowData.options)}
                          //cellRenderer={({ rowData }) => ((rowData.options?.name ?? "") + ((rowData.options?.name && rowData.options?.note) ? " | " : "") + (rowData.options?.note ?? "")) }
                          width={400}
                          flexGrow={0}
                        />
                        <Column
                          dataKey=""
                          label="Data Window Start"
                          cellRenderer={({ rowData }) => (
                            <div title={rowData.tags}>
                              {" "}
                              {timeLabel(
                                rowData?.options?.start
                              )}
                            </div>
                          )}
                          width={200}
                          flexGrow={0}
                        />
                        <Column
                          dataKey=""
                          label="Data Window End"
                          cellRenderer={({ rowData }) => (
                            <div title={rowData.tags}>
                              {" "}
                              {timeLabel(
                                rowData?.options?.end
                              )}
                            </div>
                          )}
                          width={200}
                          flexGrow={0}
                        />
                        <Column
                          dataKey=""
                          label="Actions"
                          /*cellRenderer={({ rowData }) => (
                            <ExportLink props={rowData} />
                          )}*/
                          cellRenderer={({ rowData }) => (
                            <IconButton
                              title="Click for menu of actions"
                              onClick={(e) => {
                                setExportCat(2)
                                selectedExport.current = rowData;
                                setExportMenuAnchor(e.currentTarget);
                              }}
                              style={{ padding: 6 }}
                            >
                              <ActionIcon />
                            </IconButton>
                          )}
                          width={90}
                          flexGrow={0}
                        />
                      </Table>
                    )}
                  </AutoSizer>
                )}
                {!props.data && (
                  <div>No export jobs. Use settings to create.</div>
                )}
              </div>
            </CardContent>
          </Card>
        </div>
        {exportDialogOpen && <SetupReportDialog
                               {...props}
                               dontSkipTagsPage={true}
                               reportOptions={exportOptions}
                               dialogTitle={exportDialogTitle}
                               setReportOptions={setExportOptions}
                               removeDialog={()=> setExportDialogOpen(false)}
        />}

      </Widget>
      <Menu
        id="export-menu"
        anchorEl={exportMenuAnchor}
        keepMounted
        open={Boolean(exportMenuAnchor)}
        onClose={() => setExportMenuAnchor(null)}
      >
        {
          (exportCat === 1 ? EXPORT_RECUR_ACTIONS() : EXPORT_ACTIONS()).map((action) => (
            <MenuItem
              disabled={action?.id === ACTION_DOWNLOAD ? (selectedExport.current?.status !== "finished" || (selectedExport.current?.status === "finished" && selectedExport.current?.expire && Date.now() > selectedExport.current?.expire)) : props.readOnly }
              onClick={() => {
                setExportMenuAnchor(null);
                handleAction(action);
              }}
            >
              <ListItemIcon>
                <action.icon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={action.label} />
            </MenuItem>
          ))}
      </Menu>
    </>
  );
};

export default ExportWidget;
